import { styled } from '@mui/system';
import DoneIcon from '@mui/icons-material/Done';
import { logOut } from '../../../../store/auth/authSlice';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

const ConfirmMsgContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '393px',
  height: '290px',
  margin: 'auto',
  backgroundColor: 'rgba(0, 0, 0, 0.54)',
  backdropFilter: 'blur(2px)',
  padding: '10px',
  [theme.breakpoints.down('sm')]: {
    height: '290px',
    width: '363px',
  },
}));

const InnerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  border: '1px solid #AA9178',
  padding: '48px 27px 59px 28px',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    padding: '50px 25px 60px',
  },
}));

const ConfirmTitleContainer = styled('div')({
  display: 'flex',
});

const IconBox = styled('div')({
  color: '#fff',
  paddingRight: '11px',
});

const TitleBox = styled('div')({
  '& p': {
    fontFamily: 'Fjalla One',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '25.14px',
    color: '#FFF',
    margin: '0',
  },
});

const MessageBox = styled('div')({
  '& p': {
    fontFamily: 'Raleway',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16.44px',
    color: '#FFF',
    margin: '0',
  },
});

const LoginBtn = styled('a')({
  backgroundColor: '#AA9178',
  color: '#FFF',
  padding: '3px 15px',
  cursor: 'pointer',
  height: '22px',
  width: '63px',
  fontFamily: 'Fjalla One',
  fontWeight: '400',
  fontSize: '14px',
  lineHeight: '17.6px',
  textDecoration: 'none',
});

const ConfirmMessage = () => {
  const dispatch = useDispatch();
  const handleLogOut = async () => {
    await dispatch(logOut());
  };
  useEffect(() => {
    handleLogOut();
  }, []);

  return (
    <ConfirmMsgContainer>
      <InnerContainer>
        <ConfirmTitleContainer>
          <IconBox>
            <DoneIcon />
          </IconBox>
          <TitleBox>
            <p>Your password has been updated</p>
          </TitleBox>
        </ConfirmTitleContainer>
        <MessageBox>
          <p>
            You can use your new password to sign in now. And enjoy your adventure at Coffetopia!
          </p>
        </MessageBox>
        <LoginBtn href="/signin">Login</LoginBtn>
      </InnerContainer>
    </ConfirmMsgContainer>
  );
};

export default ConfirmMessage;
